/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";

const StyledTextCircleDividerWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
`;

const StyledTextCircleDivider = styled.span`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  border-radius: 50%;
  ${(props) => colorStyles[props.$color]};
`;

const TextCircleDivider = ({ size = 4, color = "default", ...props }) => {
  return (
    <StyledTextCircleDividerWrapper {...props}>
      <StyledTextCircleDivider $size={size} $color={color} />
    </StyledTextCircleDividerWrapper>
  );
};

const colorStyles = {
  default: css`
    background: rgba(${({ theme }) => theme.colors.border.rgba});
  `,
  dark: css`
    background: rgba(${({ theme }) => theme.colors.text.rgba});
  `,
  textSecondary: css`
    background: rgba(${({ theme }) => theme.colors.textSecondary.rgba});
  `,
  accent: css`
    background: rgba(${({ theme }) => theme.colors.accent.rgba});
  `,
  accentContrast: css`
    background: rgba(${({ theme }) => theme.colors.accentContrast.rgba});
  `,
};

export default TextCircleDivider;
